<div class="gantt-legend">
  <sc-flex >
    <div class="legend-entry planned">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt.legend.planned"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry arrived-not-started">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt.legend.arrived-not-started"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry processing">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt.legend.processing"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry canceled">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt.legend.canceled"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="legend-entry finished">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.gantt.legend.finished"></sc-dictionary-label>
    </div>
  </sc-flex>
</div>

